import React, { useReducer, createContext } from "react";
import PropTypes from 'prop-types';
import { findIndex, flatten, first } from 'lodash';

export const CVBuilderContext = createContext();

function CVBuilderReducer(state, action) {
    switch (action.type) {
        case 'get': {
            const { data } = action;
            const userData = {
                userProfile: first(flatten(data)),
                workExp: data[1].filter((exp) => exp.expType.includes("Work experience")),
                volunteeringExp: data[1].filter((exp) => exp.expType.includes("Volunteering")),
                // extraCurricularExp: data[1].filter((exp) => exp.expType.includes("Extra-curricular")),
                employmentExp: data[1].filter((exp) => exp.expType.includes("Employment")),
                qualifications: data[2].filter((ach) => ach.achieveType.includes("Qualification")),
                awards: data[2].filter((ach) => ach.achieveType.includes("Award")),
                educationCerts: data[3],
                // referees: data[4].filter((sup) => sup.supType.includes("Referee")),
                portfolio: data[4].filter((sup) => sup.supType.includes("Portfolio")),
                wowchallenge: data[5]
            }
            // console.log(data);
            // console.log(userData);
            return userData;
        }

        case 'add': {
            const { item, field } = action;
            // console.log(item, field);
            // console.log(state);
            const newList = [
                ...state[field],
                item
            ]
            return {
                ...state,
                [field]: newList
            };
        }

        case 'update': {
            const { item, id, field } = action;
            // console.log(item, field, id);
            // console.log(state);
            if(field === 'userProfile') {
                return {
                    ...state,
                    userProfile: item
                }
            }
            else {
                const newList = [...state[field]];
                const index = findIndex(newList, {id});
                newList.splice(index, 1, item);
                return {
                    ...state,
                    [field]: newList
                }
            }
            
        }

        case 'remove': {
            const { id , field } = action;
            const newList = [...state[field]];
            const index = findIndex(newList, {id});
            newList.splice(index, 1);
            return {
                ...state,
                [field]: newList
            }
        }

        default: {
            throw new Error(`Unhandled action type: ${action.type}`)
        }
    }
}

export const CVBuilderContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(CVBuilderReducer, {});

    const value = {state, dispatch}

    return (
        <CVBuilderContext.Provider
        value={value}
        >
        {children}
        </CVBuilderContext.Provider>
    );
}

// PropTypes
CVBuilderContextProvider.propTypes = {
    children: PropTypes.element
}